export enum Launch_Red_Tiger {
  "es" = "es",
  "hu" = "hu",
}
